import { isLocalStorage, isIncognito } from './modules/_Utils';
import { refreshRotatingNumbers } from './modules/_mapi-rotation';
import setupAQSButtons from '../../../bifrost/assets/js/src/modules/_aqsbuttons';

const language = $('html').attr('lang') === 'es-US' ? 'es' : 'en';

$(() => {
    $(document).on('click', '.playground-details-toggle', (e) => {
        const toToggle = e.currentTarget.getAttribute('aria-controls');
        $(`#${toToggle}`).slideToggle();
        const isHidden = $(`#${toToggle}`).attr('aria-hidden') === 'true';
        $(`#${toToggle}`).attr('aria-hidden', !isHidden);
        $(
            `button[aria-controls="${toToggle}"] .playground-details-off`
        ).toggleClass('hidden');
        $(
            `button[aria-controls="${toToggle}"] .playground-details-on`
        ).toggleClass('hidden');
    });

    $(document).on('click keydown', '.playground-bottom-extra--sliced', (e) => {
        if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
            e.preventDefault(); // Prevent default behavior for Space key
            e.currentTarget.classList.toggle('showing');
            const isExpanded =
                e.currentTarget.getAttribute('aria-expanded') === 'true';
            e.currentTarget.setAttribute('aria-expanded', !isExpanded);
        }
    });

    const hidePlaygroundOverlay = () => {
        $('.playground_overlay').fadeOut();
        $('body').removeClass('no-scroll');
    };

    const setUpOverlay = () => {
        const playgroundOverlay = document.querySelector('.playground_overlay');
        if (playgroundOverlay) {
            $('body').addClass('no-scroll');
        }
    };

    setUpOverlay();

    const setupProviderDisclaimers = () => {
        const providerDisclaimers = document.querySelector(
            '.provider-disclaimers-container'
        );
        if (providerDisclaimers) {
            // remove providerDisclaimers from its location and put it back at the bottom of #main-content
            const mainContent = document.querySelector('.main-content');
            const providerDisclaimersClone =
                providerDisclaimers.cloneNode(true);
            providerDisclaimers.remove();
            mainContent.appendChild(providerDisclaimersClone);
        }
    };

    setupProviderDisclaimers();

    $(document).on('click', '.provider-disclaimers-toggle', (e) => {
        $('#provider-disclaimers-text').slideToggle();
        document
            .querySelector('.provider-disclaimers-toggle__off')
            .classList.toggle('hidden');
        document
            .querySelector('.provider-disclaimers-toggle__on')
            .classList.toggle('hidden');
        // toggle aria-expanded on provider-disclaimers-toggle
        e.currentTarget.setAttribute(
            'aria-expanded',
            e.currentTarget.getAttribute('aria-expanded') === 'true'
                ? 'false'
                : 'true'
        );
        // toggle aria-hidden on provider-disclaimers-text
        $('#provider-disclaimers-text').attr('aria-hidden', (i, attr) => {
            return attr === 'true' ? 'false' : 'true';
        });
    });

    const setupBottomExtras = () => {
        const playgroundCards = document.querySelectorAll(
            '#playground-cards .playground-card'
        );
        // loop over all the cards and check if the bottom extra is taller than one line
        // if it is, add a class that shows the toggle option

        playgroundCards.forEach((card) => {
            const bottomExtras = card.querySelectorAll(
                '.playground-bottom-extra'
            );
            bottomExtras.forEach((extra) => {
                const remainingExtraText = extra.querySelector(
                    '.playground-bottom-extra__text'
                );
                if (remainingExtraText) {
                    // the p tag or the parent could be the deal, it depends on the content entered into the block
                    if (
                        remainingExtraText.scrollHeight >
                            remainingExtraText.clientHeight ||
                        remainingExtraText.scrollWidth >
                            remainingExtraText.clientWidth
                    ) {
                        extra.classList.add('playground-bottom-extra--sliced');
                        extra.setAttribute('aria-expanded', 'false');
                        extra.setAttribute('role', 'button');
                        extra.setAttribute('tabindex', '0');
                    }
                    const remainingExtraP =
                        remainingExtraText.querySelector('p');
                    if (
                        remainingExtraP &&
                        (remainingExtraP.scrollHeight >
                            remainingExtraP.clientHeight ||
                            remainingExtraP.scrollWidth >
                                remainingExtraP.clientWidth)
                    ) {
                        extra.classList.add('playground-bottom-extra--sliced');
                        extra.setAttribute('aria-expanded', 'false');
                        extra.setAttribute('role', 'button');
                        extra.setAttribute('tabindex', '0');
                    }
                }
            });
        });
    };

    setupBottomExtras();
    //Setting global position on cards and their links for accurate reporting on clicks
    const setPlaygroundPosition = () => {
        let position = 0;
        document
            .querySelectorAll('#playground-cards .playground-card')
            .forEach((card) => {
                if (card.style.display !== 'none') {
                    position++;
                    card.dataset.globalPosition = position;
                    card.querySelectorAll('a').forEach((link) => {
                        link.dataset.globalPosition = position;
                    });
                }
            });
    };

    if (document.querySelector('.playground-card')) {
        setPlaygroundPosition();
    }

    const showZipError = (currentForm) => {
        currentForm.find('button[type="submit"]').removeClass('active');

        let errorText = 'Zip code not found';
        if (currentForm.hasClass('change-zip-form')) {
            errorText = '!';
        }

        currentForm
            .find('label.error')
            .text(errorText)
            .removeClass('hidden')
            .show();
    };

    $(document).on('submit', '.zip-finder.playground-ajax', (e) => {
        e.preventDefault();

        const currentForm = $(e.currentTarget);

        if (currentForm.valid()) {
            const zipInput = currentForm.find('input[name="zip"]');
            const zipCode = zipInput.val();

            currentForm.find('button[type="submit"]').addClass('active');

            $.ajax({
                dataType: 'json',
                url: `/wp/wp-admin/admin-ajax.php?action=zipcheck&zip=${zipCode}`,
                success: (res) => {
                    // remove existing disclaimers
                    document
                        .querySelector('.provider-disclaimers-container')
                        ?.remove();

                    if (
                        !res ||
                        typeof res.error !== 'undefined' ||
                        res === false ||
                        res.errors
                    ) {
                        showZipError(currentForm);
                        return true;
                    }

                    // store the zip code for the user
                    if (isLocalStorage() && !isIncognito()) {
                        localStorage.setItem('zip', zipCode);
                    }

                    currentForm.find('button[type="submit"]').remove('active');

                    loadPlayground(currentForm);
                },
                error: () => {
                    showZipError(currentForm);
                },
            });
        }
    });

    const loadPlayground = (currentForm) => {
        if (currentForm.valid()) {
            const zipInput = currentForm.find('input[name="zip"]');
            const zipCode = zipInput.val();

            currentForm.find('button[type="submit"]').addClass('active');

            $('#playground-data').html('').hide();
            hidePlaygroundOverlay();
            $('.gathering-zip').html(zipCode);
            $('.playground-loading').fadeIn();
            $('.playground-skeleton').addClass('animated');

            $.ajax({
                url: `/wp/wp-admin/admin-ajax.php?action=loadPlayground`,
                method: 'POST',
                data: {
                    ...playgroundData.atts, // eslint-disable-line no-undef
                    lang: language, // eslint-disable-line object-shorthand
                    zip: zipCode,
                },
                success: (res) => {
                    if (res) {
                        $('.playground-loading').hide();
                        $('.playground-skeleton').removeClass('animated');
                        $('#playground-data').html(res).fadeIn();
                        refreshRotatingNumbers(document.querySelector('#playground-data'));
                        $('#playground-cards').foundation(); // force Foundation to work on ajax content
                        setupBottomExtras(); // setup the bottom extra toggles
                        setupProviderDisclaimers(); // setup the provider disclaimers
                        setupAQSButtons(); // setup the AQS buttons
                        // set global position on all cards and their links on ajax load
                        setPlaygroundPosition();

                        // setup tune links
                        window.addTuneParams?.();

                        // setup go links
                        if (typeof initGoLinks === 'function') {
                            initGoLinks(); // eslint-disable-line no-undef
                        }
                    } else {
                        resetPlayground();
                    }
                },
                error: (er) => {
                    console.log(`Error: ${er}`);
                    resetPlayground();
                },
            });
        }
    };

    const resetPlayground = () => {
        setUpOverlay();
        $('.zip').val('');
        $('.playground_overlay_content .zip-finder label.error')
            .text('Zip code not found')
            .removeClass('hidden')
            .show();
    };

    // sort the cards
    $(document).on('change', 'select[name="sortby"]', (e) => {
        let sortBy = e.currentTarget.value;
        // make sortBy camelCase
        sortBy = sortBy.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
        const playgroundCards = Array.from(
            document.querySelectorAll('#playground-cards .playground-card')
        );

        playgroundCards.sort((a, b) => {
            const aTopCard = a.classList.contains('top-card');
            const bTopCard = b.classList.contains('top-card');

            if (aTopCard && !bTopCard) return -1;
            if (!aTopCard && bTopCard) return 1; // leave ad card on top

            const aValue = parseFloat(a.dataset[sortBy]);
            const bValue = parseFloat(b.dataset[sortBy]); // eslint-disable-line @wordpress/no-unused-vars-before-return

            // these two sort lowest to highest
            if (sortBy === 'price' || sortBy === 'listingRecommended') {
                if (aValue === '' || isNaN(aValue)) return 1;
                if (bValue === '' || isNaN(bValue)) return -1;
                if (aValue < bValue) return -1;
                if (aValue > bValue) return 1;
            } else {
                if (aValue < bValue) {
                    return 1;
                }
                if (aValue > bValue) {
                    return -1;
                }
            }

            return 0;
        });

        const playgroundCardsContainer =
            document.getElementById('playground-cards');
        const noResultsElement = playgroundCardsContainer.querySelector(
            '.playground-no-results'
        );
        playgroundCardsContainer.innerHTML = '';
        playgroundCards.forEach((card) =>
            playgroundCardsContainer.appendChild(card)
        );
        playgroundCardsContainer.appendChild(noResultsElement); // re-add no results element
        setPlaygroundPosition();
        playgroundCardsContainer.classList.add('add-animate');
        setTimeout(() => {
            playgroundCardsContainer.classList.remove('add-animate');
        }, 500);
    });

    // set filters
    $(document).on('change', '.playground-filter', () => {
        const filters = document.querySelectorAll('.playground-filter');
        const playgroundCards = document.querySelectorAll(
            '#playground-cards .playground-card'
        );
        const selectedFilters = [];

        // remove no results found message
        document
            .querySelector('#playground-cards .playground-no-results')
            .classList.add('hidden');

        filters.forEach((filter) => {
            if (filter.value !== '') {
                selectedFilters.push({
                    name: filter.name,
                    value: filter.value,
                });
            }
        });

        playgroundCards.forEach((card) => {
            const cardData = card.dataset;
            let showCard = true;
            if (card.classList.contains('top-card')) {
                showCard = true;
            } else {
                selectedFilters.forEach((filter) => {
                    if (filter.value === 'all') {
                        return;
                    }
                    if (filter.name === 'price') {
                        if (
                            parseInt(filter.value) < parseInt(cardData.price) ||
                            isNaN(parseInt(cardData.price))
                        ) {
                            showCard = false;
                        }
                    } else if (filter.name === 'true-rating') {
                        if (
                            parseInt(filter.value) >
                            parseInt(cardData.trueRating)
                        ) {
                            showCard = false;
                        }
                    } else if (filter.name === 'connection-type') {
                        if (!cardData.connectionType.includes(filter.value)) {
                            showCard = false;
                        }
                    }
                });
            }
            if (showCard) {
                card.style.display = 'flex';
            } else {
                card.style.display = 'none';
            }
        });

        // if all the cards are display none, add a message
        const allCards = Array.from(playgroundCards);
        const allCardsHidden = allCards.every(
            (card) => card.style.display === 'none'
        );
        if (allCardsHidden) {
            // add no results found message
            document
                .querySelector('#playground-cards .playground-no-results')
                .classList.remove('hidden');
        }

        setPlaygroundPosition();

        const playgroundCardsContainer =
            document.getElementById('playground-cards');
        playgroundCardsContainer.classList.add('add-animate');
        setTimeout(() => {
            playgroundCardsContainer.classList.remove('add-animate');
        }, 500);
    });

    $(document).on('click', '.playground-zip-toggle', () => {
        $('.playground-zip-form').slideToggle();
    });

    $(document).on('click', '.playground-filters-toggle', (e) => {
        e.currentTarget.classList.toggle('toggled');
        $('.playground-filters').slideToggle();
    });
});
